import { pregnancyApi } from '@/core/api/pregnancy'

export const {
  useGetPregnanciesQuery,
  useGetPregnanciesByPatientQuery,
  useGetActivePregnancyQuery,
  useGetPregnancyQuery,
  useCreatePregnancyMutation,
  useUpdatePregnancyMutation,
  useDeletePregnancyMutation,
} = pregnancyApi
